<template>
    <InputText id="email"
               class="mb-10 w-full"
               name="email"
               type="email"
               oncopy="return false"
               :required="model.required"
               :label="$translate('Checkout.Labels.Email')"
               :placeholder="model.emailHeader ? model.emailHeader : ''"
               :show-as-required="model.required"
               :validation-rules="rules"/>
    <InputText id="confirmEmail"
               class="mb-10 w-full"
               name="confirmEmail"
               type="email"
               onpaste="return false"
               :required="model.required"
               :label="$translate('Checkout.Labels.ConfirmEmail')"
               :placeholder="$translate('Checkout.Labels.ConfirmEmail')"
               :show-as-required="model.required"
               :validation-rules="confirmRules"/>
</template>

<script lang="ts" setup>
import { EmailBlock } from '@/api/content/models/email-block';
import { computed, defineProps } from 'vue';
import InputText from '../forms/InputText.vue';

type Props = {
    model: EmailBlock;
}

const props = defineProps<Props>();

const rules = computed(() => props.model.required ? 'formsEmail|formsRequired' : 'email');
const confirmRules = computed(() => props.model.required ? 'formsConfirmed:@email|formsRequired' : 'formsConfirmed:@email');

</script>
